import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import InvoiceCircleSolid from './invoice-circle-solid-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InvoiceCircleSolid {...validProps} />;
}
SvgComponent.iconName = 'invoiceCircleSolid';

export const InvoiceCircleSolidIcon = svgIconWrapper(SvgComponent);
